<template>
    <MypageVisit
        :page_title="page_title"
        :icon_class="icon_class"
        :show_error.sync="show_error"
        :error_message="error_message"
        :error_level="error_level"
        :my_page_btn_flg="my_page_btn_flg"
        :add_dia_log.sync="add_dia_log"
        :add_dia_log_message="add_dia_log_message"
        :add_dia_log_doing="add_dia_log_doing"

        :golf_course="golf_course"
        :show_golf_list_flg="show_golf_list_flg"
        :selectGolf="selectGolf"
        :show_golf_list_count_flg="show_golf_list_count_flg"
    >
        <!-- 以下内容 -->
        <template v-if="get_api_show">

            <!-- 請求額表示 -->
            <div class="col-12">
                <div class="my-2">
                    <div class="row row-notMx">
                        <div class="checkout-label">{{ settlement_no_name }}</div>
                        <div class="specificationText">{{ checkout_info.HolderNo }}</div>
                    </div>
                    <div class="mt-2 h5 row row-notMx">
                        <div class="checkout-label">氏名</div>
                        <div class="specificationText">{{ checkout_info.AttendeeName }}&nbsp;&nbsp;様</div>
                    </div>
                    <div class="mt-4 h4 row row-notMx">
                        <div class="checkout-label mb-2 mt-auto">ご請求額</div>
                        <div class="h3 billed-amount mb-2 mt-auto">￥ {{ checkout_info.BillingAmount.toLocaleString() }}</div>

                        <button
                            type="button"
                            class="mt-ms-0 mt-2 col-11 col-sm-auto ml-3 bluebackbutton btn-sm"
                            @click="openModal()"
                        >
                            &nbsp;&nbsp;明細&nbsp;&nbsp;
                        </button>
                    </div>
                </div>
            </div>

            <!-- 精算方法表示 -->
            <div class="col-sm-12">
                <hr>
                <div>
                    <h3 class="text-left mt-4 h3-boder-left">精算方法選択</h3>
                    <h6 class="text-left m-3">精算方法を選択してください。</h6>
                    <div class="row col-12 pr-0 m-0">
                        <template v-for="val in payment_method_list">
                            <div class="pl-0"
                                :key="val.PaymentMethodCode"
                                :class="{
                                    'active': (payment_method_data == val.PaymentMethodCode) ,
                                    'col-12': (payment_method_list.length == 1),
                                    'col-6': (payment_method_list.length == 2 || payment_method_list.length >= 4),
                                    'col-4': (payment_method_list.length == 3) }"
                            >
                                <label class="btn payment-method-btn shadow-sm" :class="{'active': (payment_method_data == val.PaymentMethodCode)}">
                                    <span>
                                        <input type="radio" name="payment_method_data" v-model="payment_method_data" :value="val.PaymentMethodCode"/>
                                        {{ val.PaymentMethodDisplayName }}
                                    </span>
                                </label>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="mt-4">
                    <label class="col-form-label">領収書に印字する宛名を入力してください。</label>

                    <div class="row px-3">
                        <input type="text" class="form-control col-8" name="receipt_name" v-model="receipt_name">
                        <label class="col-form-label ml-2">様</label>
                    </div>
                </div>

                <label class="col-form-label mt-4">上記内容を確認の上、<br>精算ボタンを押してください。</label>
                <button
                    type="button"
                    class="bluebackbutton col-12 mb-3"
                    @click="saveProce">
                    精算
                </button>
            </div>

            <!-- 精算情報等表示 -->
            <MypageVisitModal
                v-show="show_modal === true"
                btnName= "true"
            >
                <div class="col-sm-12">
                    <div class="my-2">
                        <div class="row row-notMx">
                            <div class="checkout-label">{{ settlement_no_name }}</div>
                            <div class="specificationText">{{ checkout_info.HolderNo }}</div>
                        </div>
                        <div class="mt-2 h5 row row-notMx">
                            <div class="checkout-label">氏名</div>
                            <div class="specificationText">{{ checkout_info.AttendeeName }}&nbsp;&nbsp;様</div>
                        </div>
                        <div class="mt-4 h4 row row-notMx">
                            <div class="checkout-label mb-2 mt-auto">ご請求額</div>
                            <div class="billed-amount mb-2 mt-auto">￥ {{ checkout_info.BillingAmount.toLocaleString() }}</div>
                        </div>
                    </div>
                    <hr>
                    <h5 class="text-left mt-2 h3-boder-left">ご明細</h5>
                    <table class="mx-3 specificationTable table table-striped">
                            <tr>
                                <th class="text-center" style="width: 60%;" scope="col"><small>項目名</small></th>
                                <th class="text-center min-width-13" style="width: 13%;" scope="col"><small>単価</small></th>
                                <th class="text-center min-width-13" style="width: 13%;" scope="col"><small>数量</small></th>
                                <th class="text-center min-width-13" style="width: 14%;" scope="col"><small>金額</small></th>
                            </tr>
                        <tbody>
                            <template v-if="checkout_detail === undefined || !(checkout_detail).length">
                                <tr>
                                    <td colspan="4" class="text-center">明細はございません。</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr style="height: 1.5rem;" v-for="data in checkout_detail[pagination - 1]" :key="data.SetNo">
                                    <td>
                                        <span><small>{{ data.SettlementName }}</small></span>
                                    </td>
                                    <td class="text-right">
                                        <span><small>{{ data.UnitPrice.toLocaleString() }}</small></span>
                                    </td>
                                    <td class="text-right">
                                        <span><small>{{ data.Quantity.toLocaleString() }}</small></span>
                                    </td>
                                    <td class="text-right">
                                        <template v-if="data.TaxationType == 1">
                                            <span><small>{{ data.WithoutTaxPrice.toLocaleString() }}</small></span>
                                        </template>
                                        <template v-if="data.TaxationType == 2 || data.TaxationType == 3 || data.TaxationType == null">
                                            <span><small>{{ data.TaxInPrice.toLocaleString() }}</small></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <nav v-if="checkout_detail.length >= 1" aria-label="Page navigation" class="w-100">
                        <ul class="pagination pagination-sm justify-content-center">
                            <li class="page-item" @click="ClickPagination('Previous')">
                                <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                            </li>
                            <li class="pagination-center">
                                <span>{{ pagination }} / {{ max_pagination }}</span>
                            </li>
                            <li class="page-item" @click="ClickPagination('Next')">
                                <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                            </li>
                        </ul>
                    </nav>

                    <button
                        type="button"
                        class="mb-2 mypagebackbutton col-12"
                        @click="openModal()">
                        戻る
                    </button>
                </div>
            </MypageVisitModal>
        </template>

        <div class="col-sm-12" v-show="save_api_show">
            <!-- 精算方法確定表示(精算番号非表示の場合) -->
            <h5 class="text-center mt-2" v-html="save_api_message" />
        </div>

        <div class="col-sm-12" v-show="code_show">
            <div class="qr-code" v-html="qr_code"></div>
            <div class="barcode" v-show="barcode_show">
                <svg id="barcode"></svg>
            </div>

            <button
                type="button"
                class="my-3 mypagebackbutton footer-btn-size"
                @click="myPage">
                マイページトップに戻る
            </button>
        </div>

    </MypageVisit>
</template>

<script>
/**
 * マイページ 精算番号参照（チェックアウト）画面
 * */
// 共通画面項目
import MypageVisit from '../components/MyPage/MypageVisit';
import MypageVisitModal from '../components/MyPage/MypageVisitModal';
// 共通JS項目
import mypageVisitMixin from '../../mixins/MyPage/mypageVisitMixin.js';
import { CODE_MASTER } from '../../config.js';
import { GET_API } from '../../constants/mypage_visit';
import validater from "../../lib/validater";

export default {
    components: {
        MypageVisit,
        MypageVisitModal,
        validater
    },
    mixins: [
        mypageVisitMixin
    ],
    data () {
        return {
            // メッセージ
            save_api_message: '',
            // 表示フラグ
            get_api_show: false,
            save_api_show: false,
            code_show: false,
            // API情報取得
            get_api_url : 'checkout_confirm',
            save_api_url : 'save_checkout',
            get_api_url_all : '',
            save_api_url_all : '',
            // 画面側選択項目
            machine_no: '',
            payment_amount: 0,
            payment_method_list: [],
            payment_method_data: '',
            settlement_no_name: '',
            receipt_name: '',

            // 明細データ
            checkout_info: [],
            checkout_detail: [],
            pagination: 1,
            max_pagination: 1,
            line_max: 15,

            // モーダル表示
            show_modal: false,
        };
    },
    // 画面作成前
    created () {
        this.page_title = 'チェックアウト';
        this.icon_class = 'icon-icon-info-profile mypage-title-icon';
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            // 約情報確認API URL取得
            if(this.json_info[this.get_api_url].length > 0){
                this.get_api_url_all = this.api_url + this.json_info[this.get_api_url];
            }
            // 確認項目保存API URL取得
            if(this.json_info[this.save_api_url].length > 0){
                this.save_api_url_all = this.api_url + this.json_info[this.save_api_url];
            }

            if(this.api_url != false ){
                // データ取得
                this.getData();
            }
        },
        /** ----------------------------------------------
         * APIを使用し、データを取得
         * ---------------------------------------------- */
        getData: async function(){
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            // 送信データ
            var postData = {
                "OfficeCode" : this.api_office_code,
                "WebMemberID" : this.member_number,
            };

            // APIでデータ送信する
            await this.$apollo.query({
                query: GET_API,
                variables: {
                    url: this.get_api_url_all,
                    key: this.api_key,
                    data: JSON.stringify(postData),
                }
            })
            // JSON型で取得
            .then(response => {
                var data = response.data.GetMypageVisitApi.data;
                return JSON.parse(data);
            })
            .then(data => {

                if(data.Result.Status == '1'){
                    // 画面表示
                    if(data.MachineNo != undefined){
                        this.machine_no = data.MachineNo;
                    }
                    if(data.PaymentAmount != undefined){
                        this.payment_amount = data.PaymentAmount.toLocaleString();
                    }
                    // 画面入力値格納配列
                    if(data.PaymentMethodList != undefined){
                        // 選択項目
                        this.payment_method_list = data.PaymentMethodList;
                        this.payment_method_data = (this.payment_method_list[0].PaymentMethodCode != undefined)? this.payment_method_list[0].PaymentMethodCode : '';
                    }

                    // 表示項目
                    if(data.CheckoutInfo != undefined){
                        this.checkout_info = data.CheckoutInfo;

                        // 宛名
                        if(this.checkout_info.ReceiptName != undefined){
                            this.receipt_name = this.checkout_info.ReceiptName;
                        }

                        // ホルダーNo名称
                        if(this.checkout_info.SettlementNoName != undefined){
                            this.settlement_no_name = this.checkout_info.SettlementNoName;
                        }
                    }

                    // ご明細
                    if(this.checkout_info.Details != undefined){

                        // 指定行ごとに配列を分割する
                        var array = this.checkout_info.Details;
                        var array_cnt = array.length;
                        for(var iii = 0; iii < array.length; iii++){
                            array[iii].SetNo = iii + 1;
                        }
                        const length = Math.ceil(array.length / this.line_max);
                        var data = new Array(length).fill().map((_, i) =>
                            array.slice(i * this.line_max, (i + 1) * this.line_max)
                        );

                        // 空行を作成する
                        for(var ii = 0; ii < data.length; ii++){
                            var add_line = this.line_max - data[ii].length;
                            for (var i = 0; i < add_line; i++) {
                                array_cnt++;

                                var detail = {
                                    SetNo: array_cnt,
                                    SettlementName: '',
                                    UnitPrice: '',
                                    Quantity: '',
                                    TaxationType: 1,
                                    WithoutTaxPrice: '',
                                    TaxInPrice: '',
                                    TaxInPrice: ''
                                }
                                data[ii].push(detail);
                            }
                        }

                        // 値格納
                        this.checkout_detail = data;

                        // ページ設定
                        this.pagination = 1;
                        this.max_pagination = this.checkout_detail.length;
                    }

                    // 画面に表示
                    this.get_api_show = true;

                // その他、メッセージがある場合
                } else if(data.Result.Message !== undefined && data.Result.Message !== null){
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message =  data.Result.Message ;
                    this.error_level = "crit";

                // その他（システムエラー・サーバーエラー等）
                }else{
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                    this.error_level = "crit";
                }
            })
            .then( e =>{
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            })
            .catch((e) => {
                console.log(e)  //エラーをキャッチし表示
                // メッセージ表示
                this.show_error = true;
                this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                this.error_level = "crit";
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            });
        },
        /** ----------------------------------------------
         * 確認ボタン押下
         *  精算方法確定APIを実行
         *  フラグによって精算番号確認APIを実行するかを判定
         * ---------------------------------------------- */
        saveProce: async function(){
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            // 送信データ
            var postData = {
                "OfficeCode" : this.api_office_code,
                "WebMemberID" : this.member_number,
                "MachineNo" : this.machine_no,
                "PaymentAmount" : this.payment_amount.replace(/,/g, ''),
                "PaymentMethodCode" : this.payment_method_data,
                "ReceiptName" : this.receipt_name,
            };

            // Fetch APIでデータ送信
            await this.$apollo.query({
                query: GET_API,
                variables: {
                    url: this.save_api_url_all,
                    key: this.api_key,
                    data: JSON.stringify(postData),
                }
            })
            // JSON型で取得
            .then(response => {
                var data = response.data.GetMypageVisitApi.data;
                return JSON.parse(data);
            })
            .then(data => {

                if(data.Result.Status == '1'){

                    // 精算完了
                    if(data.SettlementCompletedFlag == '1'){
                        // メッセージは仮
                        this.save_api_show = true;
                        this.save_api_message = data.Result.Message;
                    }else{
                        // ローディング削除
                        this.$store.commit("loading/setIsOpacityLoading", false);

                        // 表示
                        this.get_api_show = false;
                        this.code_show = true;

                        // 表示コード種類設定
                        //this.make_display_code = '0';

                        // 表示コード生成 (両方表示)
                        //if(this.make_display_code == '0'){
                            // バーコード
                            this.makeDisplayBarCode(this.member_number);
                        //}else{
                            // QRコード
                            this.makeDisplayQrCode(this.member_number);
                        //}

                    }

                // その他、メッセージがある場合
                } else if(data.Result.Message !== undefined && data.Result.Message !== null){
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message =  data.Result.Message ;
                    this.error_level = "notice";
                    // ローディング削除
                    this.$store.commit("loading/setIsOpacityLoading", false);

                // その他（システムエラー・サーバーエラー等）
                }else{
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                    this.error_level = "crit";
                    // ローディング削除
                    this.$store.commit("loading/setIsOpacityLoading", false);
                }
            })
            .catch((e) => {
                console.log(e)  //エラーをキャッチし表示
                // メッセージ表示
                this.show_error = true;
                this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                this.error_level = "crit";

                // ローディング削除
                this.$store.commit("loading/setIsOpacityLoading", false);
            });
        },
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        clickPagination: function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.max_pagination) {
                    this.pagination++;
                } else {
                    return;
                }
            }
        },
        /** ----------------------------------------------
         * 明細用モーダル開閉
         * ---------------------------------------------- */
        openModal: function(){
            this.show_modal = !this.show_modal;

            if (this.show_modal) {
                document.body.classList.add('fix-body');
            } else {
                document.body.classList.remove('fix-body');
            }
        }
    },
}
</script>

<style scoped>
.checkout-label{
    text-align: right;
    width: 105px;
}
.billed-amount {
    margin-left: 20px;
    text-align: center;
    border-bottom: 1px solid;
    padding: 0 10px;
    min-width: 160px;
}
.payment-method-btn span {
    display: table-cell;
    vertical-align: middle;
}
.payment-method-btn span input{
    position: absolute;
    clip: rect(0,0,0,0);
}
</style>
